// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #2563eb;
  /* Professional Blue */
  --primary-hover: #1d4ed8;
  --bg-color: #f8fafc;
  --text-dark: #1e293b;
  --text-light: #64748b;
  --input-border: #e2e8f0;
  --white: #ffffff;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* Main Layout */
.login-container {
  display: flex;
  min-height: 100vh;
  width: 100%;
  background-color: var(--white);
  overflow-x: hidden;
}

/* LEFT SIDE: Branding */
.login-brand-section {
  flex: 1 1;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  overflow: hidden;
}

/* Adding a subtle background pattern circle */
.login-brand-section::before {
  content: '';
  position: absolute;
  width: 400px;
  height: 400px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 50%;
  top: -100px;
  left: -100px;
}

.brand-content {
  max-width: 450px;
  z-index: 2;
  text-align: center;
  /* Center everything including logo */
}

/* ✅ NEW: University Logo Styling */
.university-logo {
  width: 120px;
  /* Adjust size as needed */
  height: auto;
  margin-bottom: 2rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  /* background: white;  Optional: if logo needs bg */
  /* padding: 10px; */
  /* border-radius: 8px; */
}

.brand-content h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.brand-content p {
  font-size: 1.1rem;
  opacity: 0.8;
  line-height: 1.6;
}

.brand-footer {
  position: absolute;
  bottom: 30px;
  left: 40px;
  font-size: 0.85rem;
  opacity: 0.5;
}

/* RIGHT SIDE: Form */
.login-form-section {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
  padding: 20px;
}

.form-wrapper {
  width: 100%;
  max-width: 420px;
  padding: 40px;
}

.form-header {
  margin-bottom: 2rem;
}

.form-header h2 {
  font-size: 2rem;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}

.form-header p {
  color: var(--text-light);
}

/* Form Elements */
.input-group {
  margin-bottom: 1.25rem;
}

.input-group label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-wrapper .icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-light);
  display: flex;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 2;
  background: none; /* removed white circle */
  padding: 0;
  border-radius: 0;
}

.input-wrapper .icon svg {
  width: 18px;
  height: 18px;
}

/* Inputs and selects share base styling */
.input-wrapper input,
.input-wrapper select {
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 1px solid var(--input-border);
  border-radius: 8px;
  font-size: 1rem;
  color: var(--text-dark);
  transition: all 0.2s ease;
  outline: none;
  background: white;
}

/* Role/ID/Phone/Email specific spacing */
.input-wrapper.role-field select,
.input-wrapper.id-field input,
.input-wrapper.phone-field input {
  padding-left: 42px;
}
/* Program select: reduce left padding so text sits closer to icon */
.input-wrapper.program-field select {
  padding-left: 44px;
}.input-wrapper.email-field input {
  padding-left: 42px;
}
/* OTP fields: match ID/Phone spacing so placeholder and icon don't overlap */
.input-wrapper.otp-field input {
  padding-left: 42px;
  padding-right: 36px;
}
/* password tweaks: bring lock icon and eye closer */
.input-wrapper.password input {
  padding-left: 40px;
  padding-right: 36px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-light);
  display: flex;
  align-items: center;
  padding: 2px;
}

.password-toggle svg {
  width: 18px;
  height: 18px;
}
/* make sure placeholder text is readable and aligned */
.input-wrapper input::placeholder {
  color: var(--text-light);
}

/* Small inline hints below fields (info / success / warn / error) */
.field-hint {
  margin-top: 6px;
  font-size: 0.88rem;
  color: var(--text-light);
  line-height: 1.3;
}

/* Make informational hints subtle and compact */
.field-hint.info {
  background: transparent;
  color: #475569; /* slightly darker muted text */
  padding: 4px 0;
  border-left: none;
  font-style: normal;
  font-size: 0.88rem;
}

/* Specific password-field spacing: reduce to bring eye closer */
.input-wrapper.password input {
  padding-left: 40px; /* bring text closer to lock icon */
  padding-right: 36px; /* keep eye button close */
}

/* Larger gap for ID and Phone inputs so placeholder sits further from icon */
.input-wrapper.id-field input,
.input-wrapper.phone-field input {
  padding-left: 40px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-light);
  display: flex;
  align-items: center;
  padding: 2px;
}

.password-toggle svg {
  width: 18px;
  height: 18px;
}

.input-wrapper input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}

/* Button Styles */
.btn-primary {
  width: 100%;
  padding: 12px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 1rem;
}

.btn-primary:hover {
  background-color: var(--primary-hover);
}

.btn-link {
  background: none;
  border: none;
  color: var(--text-light);
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: 1rem;
  width: 100%;
  text-decoration: underline;
}

/* Alerts */
.alert-box {
  padding: 12px;
  border-radius: 6px;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
}

.alert-box.error {
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fee2e2;
}

.alert-box.success {
  background-color: #f0fdf4;
  color: #16a34a;
  border: 1px solid #dcfce7;
}

.alert-box.info {
  background-color: #eff6ff;
  color: #2563eb;
  border: 1px solid #dbeafe;
}

/* OTP Specific */
.otp-header {
  background: #f1f5f9;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 0.9rem;
  color: var(--text-dark);
  border-left: 4px solid var(--primary-color);
}

.form-footer {
  margin-top: 2rem;
  text-align: center;
  font-size: 0.9rem;
  color: var(--text-light);
}

.form-footer a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}

/* Animation */
.animated-form {
  animation: fadeIn 0.4s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============ ROLE SELECTOR (UPDATED HORIZONTAL) ============ */
.role-selector {
  display: flex;
  /* Horizontal Layout */
  justify-content: center;
  gap: 1.5rem;
  margin-top: 3rem;
  width: 100%;
  flex-wrap: wrap;
  /* Allows wrapping on very small screens */
}

.role-card {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33% - 1rem);
  /* Roughly 3 cards per row */
  max-width: 140px;
  padding: 1.5rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--white);
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}

.role-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.4);
}

.role-card.active {
  background: var(--primary-color);
  border-color: #60a5fa;
  /* Slightly lighter border for contrast */
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
  transform: translateY(-5px);
}

.role-card svg {
  margin-bottom: 0.75rem;
  opacity: 1;
  stroke-width: 2.5;
  color: var(--white);
  transition: all 0.3s ease;

  /* Circle around icon */
  padding: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  width: 50px;
  /* Ensure specific width for circle */
  height: 50px;
}

/* Active Icon Styling */
.role-card.active svg {
  background-color: rgba(0, 0, 0, 0.2);
  /* Darker circle when active */
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}

.role-card h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

/* Form Placeholder when no role selected */
.form-placeholder {
  text-align: center;
  padding: 3rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.form-placeholder h2 {
  font-size: 2rem;
  color: var(--text-dark);
  margin-bottom: 0.75rem;
}

.form-placeholder p {
  font-size: 1.1rem;
  color: var(--text-light);
  line-height: 1.7;
}

/* ============ RESPONSIVE DESIGN ============ */

/* Tablet and Mobile (Devices narrower than 900px) */
@media (max-width: 900px) {
  .login-container {
    flex-direction: column;
    /* Stack top-to-bottom */
    height: auto;
  }

  /* --- Top Brand Section --- */
  .login-brand-section {
    flex: none;
    width: 100%;
    min-height: auto;
    /* Allow content to dictate height */
    padding: 40px 20px;
  }

  .brand-content h1 {
    font-size: 2rem;
  }

  .role-selector {
    margin-top: 2rem;
  }

  .role-card {
    min-height: 100px;
    /* Slightly smaller cards on mobile */
    padding: 1rem;
  }

  .brand-footer {
    display: none;
  }

  /* --- Bottom Form Section --- */
  .login-form-section {
    flex: none;
    width: 100%;
    padding: 30px 20px 50px 20px;
  }

  .form-wrapper {
    margin: 0 auto;
    padding: 0;
  }

  .form-header {
    text-align: center;
  }
}

/* Very Small Screens (Phones < 480px) */
@media (max-width: 480px) {
  .login-brand-section {
    padding: 30px 15px;
  }

  .brand-content h1 {
    font-size: 1.75rem;
  }

  .role-card {
    flex: 0 0 100%;
    /* Stack cards vertically on tiny screens */
    max-width: 100%;
    flex-direction: row;
    /* Icon left, text right */
    justify-content: flex-start;
    padding: 1rem 1.5rem;
    min-height: auto;
    gap: 15px;
  }

  .role-card svg {
    margin-bottom: 0;
    width: 40px;
    height: 40px;
    padding: 8px;
  }

  .role-card h3 {
    font-size: 1.1rem;
  }
}

/* Dropdown styling (reused from Dashboard.css but scoped here if needed) */
.input-wrapper select {
  width: 100%;
  padding: 12px 16px 12px 60px;
  border: 1px solid var(--input-border);
  border-radius: 8px;
  font-size: 1rem;
  color: var(--text-dark);
  outline: none;
  background-color: var(--white);
}

.two-col-row {
  display: flex;
  gap: 20px;
  width: 100%;
}

.two-col-row .input-group {
  flex: 1 1;
  min-width: 0;
}

@media (max-width: 768px) {
  .two-col-row {
    flex-direction: column;
    gap: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,uFAAuF;AACzF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mDAAmD;EACnD,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,gBAAgB,EAAE,yBAAyB;EAC3C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0CAA0C;AAC1C;;EAEE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;;;EAGE,kBAAkB;AACpB;AACA,oEAAoE;AACpE;EACE,kBAAkB;AACpB,CAAC;EACC,kBAAkB;AACpB;AACA,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA,uDAAuD;AACvD;EACE,wBAAwB;AAC1B;;AAEA,oEAAoE;AACpE;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,uBAAuB;EACvB,cAAc,EAAE,+BAA+B;EAC/C,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB,EAAE,mCAAmC;EACvD,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA,6EAA6E;AAC7E;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,yCAAyC;EACzC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;;EAEzB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,qCAAqC;EACrC,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gDAAgD;;AAEhD,oDAAoD;AACpD;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;EACd;;EAEA,8BAA8B;EAC9B;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,gCAAgC;EAChC;IACE,UAAU;IACV,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,2CAA2C;IAC3C,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;IACpB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;AACF","sourcesContent":[":root {\r\n  --primary-color: #2563eb;\r\n  /* Professional Blue */\r\n  --primary-hover: #1d4ed8;\r\n  --bg-color: #f8fafc;\r\n  --text-dark: #1e293b;\r\n  --text-light: #64748b;\r\n  --input-border: #e2e8f0;\r\n  --white: #ffffff;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\r\n}\r\n\r\n/* Main Layout */\r\n.login-container {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  width: 100%;\r\n  background-color: var(--white);\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* LEFT SIDE: Branding */\r\n.login-brand-section {\r\n  flex: 1;\r\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Adding a subtle background pattern circle */\r\n.login-brand-section::before {\r\n  content: '';\r\n  position: absolute;\r\n  width: 400px;\r\n  height: 400px;\r\n  background: rgba(255, 255, 255, 0.03);\r\n  border-radius: 50%;\r\n  top: -100px;\r\n  left: -100px;\r\n}\r\n\r\n.brand-content {\r\n  max-width: 450px;\r\n  z-index: 2;\r\n  text-align: center;\r\n  /* Center everything including logo */\r\n}\r\n\r\n/* ✅ NEW: University Logo Styling */\r\n.university-logo {\r\n  width: 120px;\r\n  /* Adjust size as needed */\r\n  height: auto;\r\n  margin-bottom: 2rem;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  /* background: white;  Optional: if logo needs bg */\r\n  /* padding: 10px; */\r\n  /* border-radius: 8px; */\r\n}\r\n\r\n.brand-content h1 {\r\n  font-size: 3rem;\r\n  font-weight: 700;\r\n  margin-bottom: 1rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.brand-content p {\r\n  font-size: 1.1rem;\r\n  opacity: 0.8;\r\n  line-height: 1.6;\r\n}\r\n\r\n.brand-footer {\r\n  position: absolute;\r\n  bottom: 30px;\r\n  left: 40px;\r\n  font-size: 0.85rem;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* RIGHT SIDE: Form */\r\n.login-form-section {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: var(--white);\r\n  padding: 20px;\r\n}\r\n\r\n.form-wrapper {\r\n  width: 100%;\r\n  max-width: 420px;\r\n  padding: 40px;\r\n}\r\n\r\n.form-header {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.form-header h2 {\r\n  font-size: 2rem;\r\n  color: var(--text-dark);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.form-header p {\r\n  color: var(--text-light);\r\n}\r\n\r\n/* Form Elements */\r\n.input-group {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.input-group label {\r\n  display: block;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: var(--text-dark);\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.input-wrapper .icon {\r\n  position: absolute;\r\n  left: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: var(--text-light);\r\n  display: flex;\r\n  width: 18px;\r\n  height: 18px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  pointer-events: none;\r\n  z-index: 2;\r\n  background: none; /* removed white circle */\r\n  padding: 0;\r\n  border-radius: 0;\r\n}\r\n\r\n.input-wrapper .icon svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n/* Inputs and selects share base styling */\r\n.input-wrapper input,\r\n.input-wrapper select {\r\n  width: 100%;\r\n  padding: 12px 16px 12px 48px;\r\n  border: 1px solid var(--input-border);\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  color: var(--text-dark);\r\n  transition: all 0.2s ease;\r\n  outline: none;\r\n  background: white;\r\n}\r\n\r\n/* Role/ID/Phone/Email specific spacing */\r\n.input-wrapper.role-field select,\r\n.input-wrapper.id-field input,\r\n.input-wrapper.phone-field input {\r\n  padding-left: 42px;\r\n}\r\n/* Program select: reduce left padding so text sits closer to icon */\r\n.input-wrapper.program-field select {\r\n  padding-left: 44px;\r\n}.input-wrapper.email-field input {\r\n  padding-left: 42px;\r\n}\r\n/* OTP fields: match ID/Phone spacing so placeholder and icon don't overlap */\r\n.input-wrapper.otp-field input {\r\n  padding-left: 42px;\r\n  padding-right: 36px;\r\n}\r\n/* password tweaks: bring lock icon and eye closer */\r\n.input-wrapper.password input {\r\n  padding-left: 40px;\r\n  padding-right: 36px;\r\n}\r\n\r\n.password-toggle {\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-light);\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 2px;\r\n}\r\n\r\n.password-toggle svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n/* make sure placeholder text is readable and aligned */\r\n.input-wrapper input::placeholder {\r\n  color: var(--text-light);\r\n}\r\n\r\n/* Small inline hints below fields (info / success / warn / error) */\r\n.field-hint {\r\n  margin-top: 6px;\r\n  font-size: 0.88rem;\r\n  color: var(--text-light);\r\n  line-height: 1.3;\r\n}\r\n\r\n/* Make informational hints subtle and compact */\r\n.field-hint.info {\r\n  background: transparent;\r\n  color: #475569; /* slightly darker muted text */\r\n  padding: 4px 0;\r\n  border-left: none;\r\n  font-style: normal;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n/* Specific password-field spacing: reduce to bring eye closer */\r\n.input-wrapper.password input {\r\n  padding-left: 40px; /* bring text closer to lock icon */\r\n  padding-right: 36px; /* keep eye button close */\r\n}\r\n\r\n/* Larger gap for ID and Phone inputs so placeholder sits further from icon */\r\n.input-wrapper.id-field input,\r\n.input-wrapper.phone-field input {\r\n  padding-left: 40px;\r\n}\r\n\r\n.password-toggle {\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-light);\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 2px;\r\n}\r\n\r\n.password-toggle svg {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.input-wrapper input:focus {\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);\r\n}\r\n\r\n/* Button Styles */\r\n.btn-primary {\r\n  width: 100%;\r\n  padding: 12px;\r\n  background-color: var(--primary-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: var(--primary-hover);\r\n}\r\n\r\n.btn-link {\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-light);\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  margin-top: 1rem;\r\n  width: 100%;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Alerts */\r\n.alert-box {\r\n  padding: 12px;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n  margin-bottom: 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.alert-box.error {\r\n  background-color: #fef2f2;\r\n  color: #dc2626;\r\n  border: 1px solid #fee2e2;\r\n}\r\n\r\n.alert-box.success {\r\n  background-color: #f0fdf4;\r\n  color: #16a34a;\r\n  border: 1px solid #dcfce7;\r\n}\r\n\r\n.alert-box.info {\r\n  background-color: #eff6ff;\r\n  color: #2563eb;\r\n  border: 1px solid #dbeafe;\r\n}\r\n\r\n/* OTP Specific */\r\n.otp-header {\r\n  background: #f1f5f9;\r\n  padding: 10px;\r\n  border-radius: 6px;\r\n  margin-bottom: 20px;\r\n  font-size: 0.9rem;\r\n  color: var(--text-dark);\r\n  border-left: 4px solid var(--primary-color);\r\n}\r\n\r\n.form-footer {\r\n  margin-top: 2rem;\r\n  text-align: center;\r\n  font-size: 0.9rem;\r\n  color: var(--text-light);\r\n}\r\n\r\n.form-footer a {\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Animation */\r\n.animated-form {\r\n  animation: fadeIn 0.4s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* ============ ROLE SELECTOR (UPDATED HORIZONTAL) ============ */\r\n.role-selector {\r\n  display: flex;\r\n  /* Horizontal Layout */\r\n  justify-content: center;\r\n  gap: 1.5rem;\r\n  margin-top: 3rem;\r\n  width: 100%;\r\n  flex-wrap: wrap;\r\n  /* Allows wrapping on very small screens */\r\n}\r\n\r\n.role-card {\r\n  flex: 0 0 calc(33% - 1rem);\r\n  /* Roughly 3 cards per row */\r\n  max-width: 140px;\r\n  padding: 1.5rem 1rem;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  border-radius: 12px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  color: var(--white);\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 120px;\r\n}\r\n\r\n.role-card:hover {\r\n  background: rgba(255, 255, 255, 0.15);\r\n  transform: translateY(-5px);\r\n  border-color: rgba(255, 255, 255, 0.4);\r\n}\r\n\r\n.role-card.active {\r\n  background: var(--primary-color);\r\n  border-color: #60a5fa;\r\n  /* Slightly lighter border for contrast */\r\n  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.role-card svg {\r\n  margin-bottom: 0.75rem;\r\n  opacity: 1;\r\n  stroke-width: 2.5;\r\n  color: var(--white);\r\n  transition: all 0.3s ease;\r\n\r\n  /* Circle around icon */\r\n  padding: 10px;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  width: 50px;\r\n  /* Ensure specific width for circle */\r\n  height: 50px;\r\n}\r\n\r\n/* Active Icon Styling */\r\n.role-card.active svg {\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n  /* Darker circle when active */\r\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.role-card h3 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Form Placeholder when no role selected */\r\n.form-placeholder {\r\n  text-align: center;\r\n  padding: 3rem 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n}\r\n\r\n.form-placeholder h2 {\r\n  font-size: 2rem;\r\n  color: var(--text-dark);\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.form-placeholder p {\r\n  font-size: 1.1rem;\r\n  color: var(--text-light);\r\n  line-height: 1.7;\r\n}\r\n\r\n/* ============ RESPONSIVE DESIGN ============ */\r\n\r\n/* Tablet and Mobile (Devices narrower than 900px) */\r\n@media (max-width: 900px) {\r\n  .login-container {\r\n    flex-direction: column;\r\n    /* Stack top-to-bottom */\r\n    height: auto;\r\n  }\r\n\r\n  /* --- Top Brand Section --- */\r\n  .login-brand-section {\r\n    flex: none;\r\n    width: 100%;\r\n    min-height: auto;\r\n    /* Allow content to dictate height */\r\n    padding: 40px 20px;\r\n  }\r\n\r\n  .brand-content h1 {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .role-selector {\r\n    margin-top: 2rem;\r\n  }\r\n\r\n  .role-card {\r\n    min-height: 100px;\r\n    /* Slightly smaller cards on mobile */\r\n    padding: 1rem;\r\n  }\r\n\r\n  .brand-footer {\r\n    display: none;\r\n  }\r\n\r\n  /* --- Bottom Form Section --- */\r\n  .login-form-section {\r\n    flex: none;\r\n    width: 100%;\r\n    padding: 30px 20px 50px 20px;\r\n  }\r\n\r\n  .form-wrapper {\r\n    margin: 0 auto;\r\n    padding: 0;\r\n  }\r\n\r\n  .form-header {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n/* Very Small Screens (Phones < 480px) */\r\n@media (max-width: 480px) {\r\n  .login-brand-section {\r\n    padding: 30px 15px;\r\n  }\r\n\r\n  .brand-content h1 {\r\n    font-size: 1.75rem;\r\n  }\r\n\r\n  .role-card {\r\n    flex: 0 0 100%;\r\n    /* Stack cards vertically on tiny screens */\r\n    max-width: 100%;\r\n    flex-direction: row;\r\n    /* Icon left, text right */\r\n    justify-content: flex-start;\r\n    padding: 1rem 1.5rem;\r\n    min-height: auto;\r\n    gap: 15px;\r\n  }\r\n\r\n  .role-card svg {\r\n    margin-bottom: 0;\r\n    width: 40px;\r\n    height: 40px;\r\n    padding: 8px;\r\n  }\r\n\r\n  .role-card h3 {\r\n    font-size: 1.1rem;\r\n  }\r\n}\r\n\r\n/* Dropdown styling (reused from Dashboard.css but scoped here if needed) */\r\n.input-wrapper select {\r\n  width: 100%;\r\n  padding: 12px 16px 12px 60px;\r\n  border: 1px solid var(--input-border);\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  color: var(--text-dark);\r\n  outline: none;\r\n  background-color: var(--white);\r\n}\r\n\r\n.two-col-row {\r\n  display: flex;\r\n  gap: 20px;\r\n  width: 100%;\r\n}\r\n\r\n.two-col-row .input-group {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .two-col-row {\r\n    flex-direction: column;\r\n    gap: 0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
